class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.second = 1000; // 1 Second
    this.minute = this.second * 60;
    this.hour = this.minute * 60;
    this.day = this.hour * 24;
    this.endDate = new Date(this.dataset.endDate);

    this.ticker();

    this.timer = setInterval(this.ticker.bind(this), this.second);
  }

  ticker() {
    let now = new Date();
    let distance = this.endDate - now;

    if (distance <= 0) {
      this.endDate.setDate(now.getDate() + 1);
      distance = this.endDate - now;
      //clearInterval(this.timer);
      //return;
    }

    this.querySelector(".days").innerHTML = Math.floor(distance / this.day);
    this.querySelector(".hours").innerHTML = Math.floor(
      (distance % this.day) / this.hour
    );
    this.querySelector(".minutes").innerHTML = Math.floor(
      (distance % this.hour) / this.minute
    );
    this.querySelector(".seconds").innerHTML = Math.floor(
      (distance % this.minute) / this.second
    );
  }
}

customElements.define("countdown-timer", CountdownTimer);
